import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Row, Col, Tabs, Tab } from 'react-bootstrap';

import TotalPremium from './TotalPremium';

import { Loading } from '../../components/shared'
import Limits from './Limits';
import NetQuote from './NetQuote';
import { commifyNumber } from '../../utils/utilities';
import CoverageSelector from './CoverageSelector'
import featureFlags from '../../utils/featureFlags'
import ConvertibleText from '../../components/shared/ConvertibleText'
import GCLimits from './GCLimits'
import MinimumPremium from './MinimumPremium'
import AdditionalCoverageSelector from './AdditionalCoverageSelector'
import OptionalCoverageSelector from './OptionalCoverageSelector'
import { dict } from '../constants';
import BaseRateCheck from './BaseRateCheck';
import ListContainer from './ListContainer';
import DebitNotes from '../../components/shared/DebitNotes'
import GCLimitNotes from '../../components/shared/GCLimitNotes';

const { accordion } = dict;

const accordionArrayAdditional = [
    accordion.tria
];

// As part of ArgoPI enhancement, the current optional coverage for OCP is removed. hence the below array is updated to empty
// New optional coverages in future just needs to update the array.
const accordionArrayOptionalCoverage = [];
const accordionArrayCoverage = [ accordion.standardOcp ]

const DEFAULT_COVERAGE_OPTIONS = [
    {
        label: 'Standard OCP Coverage',
        value: 'standard',
        key: 'standard',
        text: '',
        selected: true
    },
];

export const DEFAULT_ADDITIONAL_COVERAGE_OPTIONS = [
  {
    label: 'TRIA',
    key: ['terror', 'terrorPremium'],
    value: 'terror',
    text: '',
    disable: false,
    selected: true
  },
];

// As part of ArgoPI enhancement, the current optional coverage for OCP is removed. hence the below array is updated to empty
// New optional coverages in future just needs to update the array.
const COVERAGE_EXCLUSION_OPTIONS = [
];

const OCPPricing = ({
    additionalCoverage,
    optionalCoverage,
    adjustedCommission,
    basePremium,
    changePricingValue,
    defaultAdditionalCoverageOptions,
    defaultCoverageExclusionOptions,
    handleAdditionalCoverageChange,
    handleOptionalCoverageChange,
    handleNetQuote,
    isModified,
    isUnderwriter,
    limitChange,
    manuallySetPricing,
    onBlurHandler,
    options,
    pricingValues,
    submission,
    totalPremium,
    updatePricingOptions,
    defaultCoverageOptions,
    coverage,
    handleCoverageChange,
    handleBindRequest,
    rating,
    onCreditNotes,
    onGCLimitNotes,
}) => {
    const defaultCoverageExclusionOptionsHide = defaultCoverageExclusionOptions.map(option => {
      const optionCopy = {...option};
      if (optionCopy.hideElement){
        delete optionCopy.hideElement; 
      }
      return optionCopy;
    })

    let validateCreatedDate = moment(moment(submission.dateOfCreation).format('YYYY-MM-DD')).isAfter('2020-05-02');
    let validateEffDate = moment(moment(submission.anticipatedStartDate).format('YYYY-MM-DD')).isAfter('2020-05-02');
    if(!!validateEffDate && !!validateCreatedDate){
        accordion.tria.subHeader = !!accordion.tria[submission.projectAddress.projectState] ? accordion.tria[submission.projectAddress.projectState] : accordion.tria.otherStates
    }
    else{
        accordion.tria.subHeader = accordion.tria.default;
    }
    const subjectivities = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivities;
    const subjectivitiesTBD = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivitiesDescription;
    const glCoverages = submission.coverages.gl;
   
    const PricingTab = (
        <div className="netquote-container">
            <Limits defaultValue={submission.limitsRequested} onChange={limitChange} name="limitsRequested" type={submission.type} values={submission}/>
            <NetQuote handleNetQuote={handleNetQuote} adjustedCommission={adjustedCommission} baseCommission={submission.commission} />
            <Row>
                <Col xs={8} md={6} className="excessPremiumGrid">

                    <CoverageSelector
                        value={coverage}
                        basePremium={pricingValues.basePremium}
                        defaultCoverageOptions={defaultCoverageOptions}
                        accordionArray={accordionArrayCoverage}
                        extraOptions={options}
                        onChange={handleCoverageChange}
                        manuallySetPricing={manuallySetPricing}
                        pricingValues={pricingValues}
                        onBlurHandler={onBlurHandler}
                        updatePricingOptions={updatePricingOptions}
                        changePricingValue={changePricingValue}
                        isModified={isModified}
                        rating={rating}
                        submission={submission}
                    />
                    {(manuallySetPricing && isUnderwriter) && (submission.limitsRequested === "12") && <BaseRateCheck submission={submission}/> }
                    {(manuallySetPricing && isUnderwriter) && <DebitNotes onCreditNotes={onCreditNotes} submission={submission}/>}
                    <AdditionalCoverageSelector
                        accordionArray={accordionArrayAdditional}
                        changePricingValue={changePricingValue}
                        defaultAdditionalCoverageOptions={defaultAdditionalCoverageOptions}
                        extraOptions={options}
                        isModified={isModified}
                        manuallySetPricing={manuallySetPricing}
                        onBlurHandler={onBlurHandler}
                        onChange={handleAdditionalCoverageChange}
                        pricingValues={pricingValues}
                        type='ocp'
                        submission={submission}
                        updatePricingOptions={updatePricingOptions}
                        value={additionalCoverage}
                    />
                </Col>
            </Row>

            <TotalPremium id="totalPremium" isModified={isModified} surcharge={pricingValues.surcharge} totalPremium={pricingValues.totalPremium} selectedBaseCoverage={glCoverages.base} manuallySetPricing={manuallySetPricing} onBlurHandler={onBlurHandler}/>

            {(manuallySetPricing && isUnderwriter) && <GCLimits
            isModified={isModified}
            limits={pricingValues.limits}
            onBlurHandler={onBlurHandler}
            manuallySetPricing={manuallySetPricing}
            type={submission.type}
            />}
            {(manuallySetPricing && isUnderwriter) && <GCLimitNotes onGCLimitNotes={onGCLimitNotes} submission={submission}/>}
        </div>
    );

    const QuoteTab = (
        <div>            
        {(manuallySetPricing && isUnderwriter) && <MinimumPremium
                isModified={isModified}
                limits={pricingValues}
                onBlurHandler={onBlurHandler}
                manuallySetPricing={manuallySetPricing}
                type={submission.type}
        />}
        {(manuallySetPricing && isUnderwriter) && <ListContainer
              onBlurHandler={onBlurHandler}
              list={subjectivities}
              title="Subjectivities (Prior To Binding)"
              id="subjectivities"
            />}
        {(manuallySetPricing && isUnderwriter) && <ListContainer
              onBlurHandler={onBlurHandler}
              list={subjectivitiesTBD}
              title="Subjectivities (Within 10Days of Binding)"
              id="subjectivitiesDescription"
      />}
        </div>
    );

    const SinglePageDisplay = (
        <div>
          {PricingTab}
          {QuoteTab}
        </div>
      );
    
      const TabbedDisplay = (
        <Tabs defaultActiveKey={1} id="oipricing-tabbed-display" animation={false}>
          <Tab eventKey={1} title="Pricing" tabClassName="tab-header">
            {PricingTab}
          </Tab>
          <Tab eventKey={2} title="Quote" tabClassName="tab-header">
            {QuoteTab}
          </Tab>
        </Tabs>
      );

  return (
    <div>
        {(manuallySetPricing && isUnderwriter) ? TabbedDisplay: SinglePageDisplay}        
    </div>
  );
};

export default connect(
    store => {
        return {
            defaultCoverageOptions: DEFAULT_COVERAGE_OPTIONS,
            defaultAdditionalCoverageOptions: DEFAULT_ADDITIONAL_COVERAGE_OPTIONS,
            defaultCoverageExclusionOptions: COVERAGE_EXCLUSION_OPTIONS,
        };
    },
)(OCPPricing);
